import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["allTab", "todoTab", "startedTab", "endedTab",
                    "reviewAllTab", "reviewNoneTab", "reviewDecidingTab", "reviewApprovedTab", "reviewRejectedTab",
                    "card"]

  connect() {
    this.currentFilter = ""
    this.currentReviewFilter = ""
    this.setActiveTab(this.allTabTarget)
    if (this.hasReviewAllTabTarget) this.setActiveReviewTab(this.reviewAllTabTarget)
  }

  // Re-sort when a card is added or replaced via broadcast
  cardTargetConnected() {
    this.sortCards()
  }

  filterAll(event) {
    event.preventDefault()
    this.currentFilter = ""
    this.setActiveTab(this.allTabTarget)
    this.showCards()
  }

  filterTodo(event) {
    event.preventDefault()
    this.currentFilter = "todo"
    this.setActiveTab(this.todoTabTarget)
    this.showCards()
  }

  filterStarted(event) {
    event.preventDefault()
    this.currentFilter = "started"
    this.setActiveTab(this.startedTabTarget)
    this.showCards()
  }

  filterEnded(event) {
    event.preventDefault()
    this.currentFilter = "ended"
    this.setActiveTab(this.endedTabTarget)
    this.showCards()
  }

  filterReviewAll(event) {
    event.preventDefault()
    this.currentReviewFilter = ""
    this.setActiveReviewTab(this.reviewAllTabTarget)
    this.showCards()
  }

  filterReviewNone(event) {
    event.preventDefault()
    this.currentReviewFilter = "none"
    this.setActiveReviewTab(this.reviewNoneTabTarget)
    this.showCards()
  }

  filterReviewDeciding(event) {
    event.preventDefault()
    this.currentReviewFilter = "deciding"
    this.setActiveReviewTab(this.reviewDecidingTabTarget)
    this.showCards()
  }

  filterReviewApproved(event) {
    event.preventDefault()
    this.currentReviewFilter = "approved"
    this.setActiveReviewTab(this.reviewApprovedTabTarget)
    this.showCards()
  }

  filterReviewRejected(event) {
    event.preventDefault()
    this.currentReviewFilter = "rejected"
    this.setActiveReviewTab(this.reviewRejectedTabTarget)
    this.showCards()
  }

  setActiveTab(activeTab) {
    [this.allTabTarget, this.todoTabTarget, this.startedTabTarget, this.endedTabTarget].forEach(tab => {
      tab.classList.remove("border-blue-500", "text-blue-600")
      tab.classList.add("border-transparent", "text-gray-500")
    })

    activeTab.classList.remove("border-transparent", "text-gray-500")
    activeTab.classList.add("border-blue-500", "text-blue-600")
  }

  setActiveReviewTab(activeTab) {
    const reviewTabs = [
      this.reviewAllTabTarget,
      this.reviewNoneTabTarget,
      this.reviewDecidingTabTarget,
      this.reviewApprovedTabTarget,
      this.reviewRejectedTabTarget
    ]
    reviewTabs.forEach(tab => {
      tab.classList.remove("bg-sapphire", "text-white")
      tab.classList.add("bg-gray-100", "text-gray-600")
    })
    activeTab.classList.remove("bg-gray-100", "text-gray-600")
    activeTab.classList.add("bg-sapphire", "text-white")
  }

  sortCards() {
    const container = this.cardTargets[0]?.closest("[id='cards_list_content']")
    if (!container) return

    const frames = [...container.querySelectorAll(":scope > turbo-frame")]
    frames.sort((a, b) => {
      const cardA = a.querySelector("[data-state]")
      const cardB = b.querySelector("[data-state]")
      if (!cardA || !cardB) return 0

      const endedA = cardA.dataset.state === "ended" ? 1 : 0
      const endedB = cardB.dataset.state === "ended" ? 1 : 0

      // Active cards first, then ended
      if (endedA !== endedB) return endedA - endedB

      // Ended cards: most recently updated first
      if (endedA === 1) {
        return (cardB.dataset.updatedAt || "").localeCompare(cardA.dataset.updatedAt || "")
      }

      // Active cards: keep original DOM order (position-based from server)
      return 0
    })

    frames.forEach(frame => container.appendChild(frame))
  }

  showCards() {
    this.sortCards()

    this.cardTargets.forEach(card => {
      const cardState = card.dataset.state
      const cardReview = card.dataset.reviewStatus

      const stateMatch = this.currentFilter === "" || cardState === this.currentFilter
      const reviewMatch = this.currentReviewFilter === "" || cardReview === this.currentReviewFilter

      if (stateMatch && reviewMatch) {
        card.classList.remove("hidden")
      } else {
        card.classList.add("hidden")
      }
    })

    const visibleCards = this.cardTargets.filter(card => !card.classList.contains("hidden"))
    const emptyState = this.element.querySelector("[data-empty-state]")

    if (visibleCards.length === 0 && emptyState) {
      emptyState.classList.remove("hidden")
    } else if (emptyState) {
      emptyState.classList.add("hidden")
    }
  }
}
